import servicePregunta from '@/services/GsEncuesta/pregunta'

export default {
  PREGUNTA_FIND_ALL(_, params) {
    return new Promise((resolve, reject) => {
      servicePregunta.findAll(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PREGUNTA_FIND(_, params) {
    return new Promise((resolve, reject) => {
      servicePregunta.find(params.id).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PREGUNTA_FIND_BY_ENCUESTA(_, params) {
    return new Promise((resolve, reject) => {
      servicePregunta.findByEncuesta(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PREGUNTA_CREATE(_, params) {
    return new Promise((resolve, reject) => {
      servicePregunta.create(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PREGUNTA_UPDATE(_, params) {
    return new Promise((resolve, reject) => {
      servicePregunta.update(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PREGUNTA_UPDATE_ORDEN(_, params) {
    return new Promise((resolve, reject) => {
      servicePregunta.updateOrden(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PREGUNTA_UPDATE_GRUPO_OPCION(_, params) {
    return new Promise((resolve, reject) => {
      servicePregunta.updateGrupoOpcion(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  PREGUNTA_DELETE(_, params) {
    return new Promise((resolve, reject) => {
      servicePregunta.delete(params).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
}
